import { api } from './core'

export const inquiryApi = {
  list: (params) => api.get('/inquiry', params),
  detail: (_id) => api.get('/inquiry/medi/single', { _id }),
  delete: (_id) => api.delete('/inquiry', { _id }),
  create: (form) => api.formPost('/inquiry', form),
  update: (form) => api.formPut('/inquiry', form),
}
